(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/views/rounds.js') >= 0) return;  svs.modules.push('/modules/game-results/views/rounds.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.game_results=_svs.game_results||{};
_svs.game_results.templates=_svs.game_results.templates||{};
svs.game_results.templates.rounds = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "    <span class=\"f-bold f-400 center-text\">Det finns inga omgångar <br/> välj ett annat datum.</span>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "    <div id=\"game-results-live\" class=\"animate animate-show animate-delay-4ms\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"noRounds") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});
Handlebars.partials['svs-game_results-rounds'] = svs.game_results.templates.rounds;
})(svs, Handlebars);


 })(window);